/* eslint-disable @typescript-eslint/no-empty-interface */
import { useDesktop } from '@revenuewell/logic-desktop';
import { useProduct } from '@revenuewell/logic-product';
import React, { useEffect } from 'react';
import useLwpWidgetProps from '../hooks/use-lwp-widget-props/hooks';
import { CallList } from './legacy-call/call-list';

export interface ILwpWidgetProps {
  events?: {
    onPatientProfileClick?(phoneNumber: string): void;
  };
}

const Widget: React.FC<ILwpWidgetProps> = (props) => {
  const { setWidgetProps } = useLwpWidgetProps();

  useEffect(() => {
    setWidgetProps(props);
  }, [props]);

  return <CallList />;
};

export const LwpPhoneWidget: React.FC<ILwpWidgetProps> = (props) => {
  const { isDesktopApplication, isDesktopWidget } = useDesktop();
  const { hasProduct } = useProduct();

  return hasProduct('phone') || hasProduct('phone1') || (isDesktopApplication() && isDesktopWidget) ? (
    <Widget {...props} />
  ) : null;
};
